import React from 'react';
import { GetServerSideProps } from 'next';
import CenteredContainer from '@/common/CenteredContainer';
import CommunityAffairsPage from '@/shared/pages/community-affairs';

import initializePage from '../app/common/pageSetup';

const CommunityAffairs = (): JSX.Element => (
    <>
      <CenteredContainer>
        <CommunityAffairsPage />
      </CenteredContainer>
    </>
  );

export const getServerSideProps: GetServerSideProps = (ctx) => initializePage(ctx, 'community-affairs');

export default CommunityAffairs;
